import { Suspense, useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { SubTitle } from "../../Components/CustomComponents/index.js";
import Table from "../../Components/Table/Table.js";
import Toast, { SuccessToast } from "../../Hooks/useToast.js";
import styles from "./styles/user_management.module.scss";
// import { ToastContainer, toast } from "react-toastify";

import { useDispatch } from "react-redux"; // for getting and setting data into local redux
// import CustomerBlockModal from "../../Components/Modals/CustomerBlockModal";
import { Col, Row, Spinner } from "react-bootstrap";
import { CgDetailsMore } from "react-icons/cg";
// import EditBusinessTypeModal from "../../Components/Modals/EditBusinessTypeModal.js";
import { useForm } from "react-hook-form";
import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
import SelectFieldComponent from "../../Components/CustomComponents/SelectFieldComponent.js";
import SwitchWithLoader from "../../Components/CustomComponents/SwitchWithLoader.js";
import ToolTip from "../../Components/CustomComponents/ToolTip.js";
import UserAvatar from "../../Components/CustomComponents/UserAvatar.js";
import ShopDetailsModal from "../../Components/Modals/ShopDetailsModal.js";
import {
  useBlockUserMutation,
  useUnBlockUserMutation,
} from "../../Data/services/generalUserApi.js";
import {
  useGetAllShopQuery,
  useUpdateShopMutation,
} from "../../Data/services/shopApi.js";
import { getShopStatus, shopStatus } from "../../Helper/index.js";
import { useGetAllTransactionQuery } from "../../Data/services/transactionApi.js";

const TransactionManagementScreen = ({ setPage }) => {
  const { control, watch } = useForm({
    defaultValues: {
      status: "",
      is_blocked: "",
    },
  });

  const statusWatch = watch("status");
  const isBlockedWatch = watch("is_blocked");
  console.log(statusWatch);
  console.log(isBlockedWatch);

  const dispatch = useDispatch();

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");

  const [loading, setLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo

  const [searchQuery, setSearchQuery] = useState("");

  const filterStatusData = [
    {
      value: "all",
      label: "All",
    },
    ...shopStatus.map((value) => ({
      value: value,
      label: getShopStatus(value),
    })),
  ];

  const filterData = [
    {
      value: "all",
      label: "All",
    },
    {
      value: 0,
      label: "Active",
    },
    {
      value: 1,
      label: "InActive",
    },
  ];

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllTransactionQuery(
      {
        search: searchQuery.length >= 3 ? searchQuery : "",
        limit: pageSize,
        page: currentPage,
        is_blocked:
          isBlockedWatch && isBlockedWatch === "all" ? "" : isBlockedWatch,
        status: statusWatch && statusWatch === "all" ? "" : statusWatch,
      },
      { refetchOnMountOrArgChange: true }
    );

  useEffect(() => {
    if (data) {
      // console.log(data);
      setPageSize(data.links.per_page);
      setCurrentPage(data.links.current);
      setTotalRecords(data.links.total_records);
      setTotalPages(data.links.total);
      setRowData(data.data);
      setDataFetched(true);

      if (data.data.length === 0) {
        setIndicationMessage("Data not available");
      }
    }
  }, [data]);

  // const debouncedSearch = useCallback(
  //   debounce((query) => {
  //     console.log("Search query:", query);
  //     // local search logic
  //     const filtered = dummy_data.filter((item) =>
  //       [item.firstname, item.lastname, item.username, item.email]
  //         .filter(Boolean) // Remove null/undefined fields
  //         .some((field) => field.toLowerCase().includes(query.toLowerCase()))
  //     );

  //     setRowData(filtered);

  //     // Trigger your search logic or API here
  //   }, 500), // Adjust debounce delay as needed
  //   []
  // );

  const [selectedType, setSelectedType] = useState(10);
  const typeList = [
    // { label: "Pending", value: 10 },
    { label: "Approved", value: 20 },
    { label: "Rejected", value: 30 },
  ];

  const [update, { isLoading: updating }] = useUpdateShopMutation();

  const handleDynamicTypeChange = async (value, row) => {
    console.log(value);
    console.log(row);
    setSelectedType(value);

    const data = {
      status: parseInt(value),
    };

    try {
      const response = await update({
        data: data,
        id: row.id,
      }).unwrap();
      console.log(response);

      if (response.code === 200) {
        refetch();
        SuccessToast(response?.message);
      }
    } catch (error) {
      console.log(error);
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
    }
  };

  const handleSearchChange = (event) => {
    const query = event.target.value;
    // console.log("Search query:", query); // You can use this to trigger a search function
    setSearchQuery(query);

    // debouncedSearch(query);
  };

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setEditedData("");
  };

  const handleEditModalOpen = () => {
    setEditModal(true);
  };

  const handleEditModalClose = () => {
    setEditModal(false);
    setEditedData("");
  };

  const handleAddUser = () => {
    setEditModal(true);
  };

  const [blockUser, { isLoading: isBlocking }] = useBlockUserMutation();
  const [unBlockUser, { isLoading: isUnBlocking }] = useUnBlockUserMutation();

  const handleBlockOrUnblock = async (userSlug, isBlock) => {
    console.log(userSlug);
    console.log(isBlock);

    try {
      let response;
      if (isBlock) {
        response = await unBlockUser({ id: userSlug });
      } else {
        response = await blockUser({ id: userSlug });
      }
      console.log(response);

      if (response.data.code === 200) {
        await refetch();
        setLoading(false);
        // handleBlockModalClose();
        SuccessToast(response.data?.message);
      }
    } catch (error) {
      // console.log(error);
      Toast(error.message, "error");
    }
  };

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "user.firstname",
      text: "Name",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "180px" },
      formatter: (cellContent, row) => {
        const fullName = `${row.user.firstname} ${row.user.lastname}`;
        return (
          <UserAvatar username={fullName} image_url={row.user.image_url} />
        );
      },
    },
    {
      dataField: "transaction_type",
      text: "Type",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "120px" },
      formatter: (cellContent) => (
        <span
          className={`badge ${
            cellContent === "credit" ? "bg-success" : "bg-danger"
          }`}
        >
          {cellContent}
        </span>
      ),
    },
    {
      dataField: "previous_amount",
      text: "Previous Balance",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "150px" },
      formatter: (cellContent) => `$${cellContent}`,
    },
    {
      dataField: "transaction_amount",
      text: "Amount",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "120px" },
      formatter: (cellContent) => `$${cellContent}`,
    },
    {
      dataField: "new_amount",
      text: "New Balance",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "150px" },
      formatter: (cellContent) => `$${cellContent}`,
    },
    {
      dataField: "status",
      text: "Status",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "120px" },
      formatter: (cellContent) => (
        <span
          className={`badge ${
            cellContent === "succeeded" ? "bg-success" : "bg-warning"
          }`}
        >
          {cellContent}
        </span>
      ),
    },
    {
      dataField: "description",
      text: "Description",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "250px" },
      formatter: (cellContent, row) => {
        return <span className="lc-2 text-wrap-custom">{cellContent}</span>;
      },
    },
    {
      dataField: "createdAt",
      text: "Date",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "180px" },
      formatter: (cellContent) => {
        const date = new Date(cellContent).toLocaleString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
        return <span className="text-white-50 small"> {date} </span>;
      },
    },
  ];

  return (
    <div className={styles.MainContainer}>
      {/* {deleteModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DeleteModal
            handleDeleteModalClose={handleDeleteModalClose}
            data={editedData}
            isDeleting={isDeleting}
            onDelete={deleteData}
          />
        </Suspense>
      ) : (
        ""
      )} */}

      {editModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <ShopDetailsModal
            handleEditModalClose={handleEditModalClose}
            editData={editedData}
            refetch={refetch}
          />
        </Suspense>
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <Row className="w-100 align-items-center">
          <Col md={6}>
            <div>
              <SubTitle text={"Transaction Management"} classes="" />
            </div>
          </Col>

          {/* <Col md={6}>
            <div className="d-flex align-items-center  gap-2 ms-auto">
              <span style={{ width: "250px" }}>
                <Input
                  placeholder="Search by name"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
              </span>

              <Controller
                control={control}
                name="status"
                render={({ field: { onChange, value } }) => (
                  <span style={{ width: "250px" }}>
                    <SelectFieldComponent
                      style={{ width: "200px" }}
                      firstOption={_.isEmpty(value) ? "Select Status" : value}
                      optionsList={filterStatusData}
                      onSelectChange={onChange}
                    />
                  </span>
                )}
              />

              <Controller
                control={control}
                name="is_blocked"
                render={({ field: { onChange, value } }) => (
                  <span style={{ width: "250px" }}>
                    <SelectFieldComponent
                      style={{ width: "200px" }}
                      firstOption={_.isEmpty(value) ? "Select Status" : value}
                      optionsList={filterData}
                      onSelectChange={onChange}
                    />
                  </span>
                )}
              />
            </div>
          </Col> */}
        </Row>

        {/* {
          <Row>
            <Col md={12}>
              <Button
                classes={`${styles.cardBtn} `}
                text="Add Question"
                onClick={handleAddUser}
              ></Button>
            </Col>
          </Row>
        } */}
      </div>

      <div
        className={`${styles.mainTable} ${
          dataFetched && isFetching ? "blur-table" : ""
        }`}
      >
        {!dataFetched || isLoading ? (
          <CustomLoader />
        ) : (
          <div className={styles.mainTable}>
            {
              <Table
                // classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
                data={rowData || []}
                columns={columns}
                indication={indication}
                totalRecords={totalRecords} // todo
                totalPages={totalPages} // todo
                pageSize={pageSize} // todo
                currentPage={currentPage} // todo
                setCurrentPage={setCurrentPage} // todo
                setPageSize={setPageSize} // todo
                refetch={refetch} // todo
                // refetch={() => {}} // todo
              />
            }
          </div>
        )}
      </div>
    </div>
  );
};

export default TransactionManagementScreen;
